import React from 'react';
import {useAttributeSetSelectionProvider} from '@netx/core-attribute-set-selection';
import {EmptyStateFallbackMessage} from '@netx/core-components/EmptyStateFallbackMessage';
import {i18n} from '@netx/core/i18n';
import {useAttributeSetsProvider} from '../../contexts';
import type {
	AttributeSetId,
	AttributeSetTemplates,
	IAttributeSet,
} from '../../types';
import {AttributeSet, AttributeSetProps} from '../Set';

export interface AttributeSetsProps extends Omit<
	AttributeSetProps,
	'attributes' | 'id' | 'name' | 'title'
> {
	attributeTemplates: AttributeSetTemplates;
	sets: IAttributeSet[];
	setsLoaded?: AttributeSetId[];
}

export const AttributeSetsPrimitive = ({
	attributeTemplates,
	sets,
	setsLoaded,
	loading,
	...props
}: AttributeSetsProps) => {
	if (!loading && !sets.length) {
		return (
			<EmptyStateFallbackMessage
				disablePadding
				title={i18n.t('i18n.noAttributeSetsSelected')}
			/>
		);
	}

	return (
		<>
			{sets.map((attributeSet) => (
				<AttributeSet
					key={attributeSet.id}
					attributes={attributeTemplates[attributeSet.id]}
					id={attributeSet.id}
					{...props}
					loading={
						(setsLoaded != null && !setsLoaded.includes(attributeSet.id)) ||
						loading
					}
				/>
			))}
		</>
	);
};

export const AttributeSets = AttributeSetsPrimitive;

export default AttributeSets;

export interface AttributeSetsContainerProps extends Omit<
	AttributeSetsProps,
	'sets' | 'attributeTemplates' | 'orderUpdated'
> {
	//ids: string[];
}

// TODO: this should just take ids and use the attributeSet context to get them - so pass in selected
// this will decouple this
export const AttributeSetsContainer = ({
	//ids,
	...props
}: AttributeSetsContainerProps) => {
	const attributeSetSelection = useAttributeSetSelectionProvider();
	const attributeSets = useAttributeSetsProvider();
	// TODO: attribute sets should get the templates, we always want the templates in the end
	// templates do not change regularly
	// const set = attributeSets.getByIds(ids);
	//

	return (
		<AttributeSets
			attributeTemplates={attributeSetSelection.attributeTemplates}
			lookupsAllowed={attributeSetSelection.lookupsAllowed}
			sets={attributeSets.getByIds(attributeSetSelection.selected)}
			setsLoaded={attributeSetSelection.loadedSets}
			{...props}
		/>
	);
};
